module.exports = __webpack_public_path__ + "assets/3354fea61f33f18b982c039db5d9c941.png";